import axios from 'axios'; // 引入axios
import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
import store from './../store/index'


axios.defaults.baseURL = store.state.HttpsUrl;
// 环境的切换
// if (process.env.NODE_ENV == 'development') { // 本地开发环境
//     console.log(1,process.env.NODE_ENV)
//     axios.defaults.baseURL = store.state.HttpsUrl;
//     console.log("22",axios.defaults.baseURL,store.state.HttpsUrl)
// }else if (process.env.NODE_ENV == 'production') {//打包上线之后返回状态
//     console.log(3,process.env.NODE_ENV)
//     axios.defaults.baseURL = store.state.HttpApi;
// }

//axios.defaults.timeout = 10000; //设置默认的请求超时时间
let ContentTypes = () => { 
     var tokens = sessionStorage.getItem("token");
	
    if (tokens) {  
        axios.defaults.headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Authorization": tokens
        }
    } else {
        window.location.href = axios.defaults.baseURL+"/schoolPoints/wxindex/oauth"
    }
	
}
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function get(url, params) {
    return new Promise((resolve, reject) => {
        ContentTypes();
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        ContentTypes();
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

export function post2(url, params) {
    return new Promise((resolve, reject) => {
        ContentTypes();
        axios.post(url,QS.stringify(params,{arrayFormat:'indices',allowDots:true}))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
